module.exports = __webpack_public_path__ + "static/media/15.954f4003.png";